export default __webpack_public_path__ + "static/media/sidebar.e3d55382.svg";